import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { Button, Checkbox, Icon, Radio, Select, translate } from '@haldor/ui';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { getActiveSchool } from 'helpers/localstorage';
import { setPageTitle } from 'actions/header';
import { Block } from '@haldor/ui';
import { Spinner } from 'UI';
import Moment from 'moment';
import { getArchivedEducationGroups, getEducationGroups, getLegacyEducationGroups } from 'actions/sections';
import { getCoursesUsedWithinMySections } from 'actions/assessments';
import './_SubjectPage.scss';
import DatePickers from 'containers/Progress/Partials/DatePickers';
import DateTime from '_class/DateTime';
import { getUserAssessmentDates } from 'helpers/user';
import DatePickerFromTo from 'containers/Forms/Partials/DatePickerFromTo';

var SubjectPage = /*#__PURE__*/function (_Component) {
  _inherits(SubjectPage, _Component);

  var _super = _createSuper(SubjectPage);

  function SubjectPage(props) {
    var _this;

    _classCallCheck(this, SubjectPage);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.props.setPageTitle(_this.props.translate('verdicts'));

              if (!_this.state.filter.showArchivedLegacySections) {
                _context.next = 4;
                break;
              }

              _context.next = 4;
              return _this.handleArchivedAndLegacyGroupsVisibilityChange(true);

            case 4:
              _context.next = 6;
              return _this.reloadData();

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    _defineProperty(_assertThisInitialized(_this), "reloadData", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var filter, from, to;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this.setState({
                loading: true
              });

              filter = _this.state.filter;
              from = Moment(_this.state.filter.dates.start).format("YYYY-MM-DD");
              to = Moment(_this.state.filter.dates.end).format("YYYY-MM-DD");
              _context2.next = 6;
              return _this.props.getCoursesUsedWithinMySections(from, to);

            case 6:
              _this.setState({
                loading: false
              });

            case 7:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              localStorage.setItem("hal.subjectPageFilter", JSON.stringify(_this.state.filter));

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    })));

    _defineProperty(_assertThisInitialized(_this), "filterOnGroup", function (event) {
      var sectionId = parseInt(event.target.value, 10);
      var filter = _this.state.filter;
      filter.sectionId = sectionId;

      _this.setState({
        filter: filter
      });
    });

    _defineProperty(_assertThisInitialized(_this), "filterOnSubject", function (event) {
      var subjectId = parseInt(event.target.value, 10);
      var filter = _this.state.filter;
      filter.subjectId = subjectId;

      _this.setState({
        filter: filter
      });
    });

    _defineProperty(_assertThisInitialized(_this), "filterOnYear", /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(event) {
        var yearId, filter, yearData;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                yearId = parseInt(event.target.value, 10);
                filter = _this.state.filter;
                filter.yearId = yearId;

                _this.setState({
                  filter: filter,
                  loading: true
                });

                yearData = _this.state.years.find(function (data) {
                  return data.id == yearId;
                });
                _context4.next = 7;
                return _this.props.getCoursesUsedWithinMySections(yearData.from, yearData.to);

              case 7:
                _this.setState({
                  loading: false
                });

              case 8:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      return function (_x) {
        return _ref4.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "renderGroupRow", function (data) {
      return /*#__PURE__*/React.createElement(Link, {
        to: "/groups/".concat(data.group.id, "/course/").concat(data.course.id),
        className: "group-item",
        key: data.group.id + '-' + data.course.id
      }, /*#__PURE__*/React.createElement("div", {
        className: "row course"
      }, /*#__PURE__*/React.createElement("div", {
        className: "column group-title"
      }, data.group.title, data.group.type === 'EDUCATION_GROUP_LEGACY' ? /*#__PURE__*/React.createElement("div", {
        className: "card-meta",
        style: {
          marginLeft: '1.2rem'
        }
      }, _this.props.translate('Deleted')) : null, data.group.archived ? /*#__PURE__*/React.createElement("div", {
        className: "card-meta",
        style: {
          marginLeft: '1.2rem'
        }
      }, _this.props.translate('Archived')) : null), /*#__PURE__*/React.createElement("div", {
        className: "column"
      }, /*#__PURE__*/React.createElement("div", {
        className: "name --size-12"
      }, /*#__PURE__*/React.createElement("span", {
        className: "dot",
        style: {
          backgroundColor: data.course.colorCode
        }
      }), "".concat(data.course.title, " ").concat(data.course.courseCode)))));
    });

    _defineProperty(_assertThisInitialized(_this), "clearSubjectFilterSelection", function () {
      var filter = _this.state.filter;
      filter.subjectId = 0;

      _this.setState({
        filter: filter
      });
    });

    _defineProperty(_assertThisInitialized(_this), "clearGroupFilterSelection", function () {
      var filter = _this.state.filter;
      filter.sectionId = 0;

      _this.setState({
        filter: filter
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderSubjectsFilter", function () {
      return /*#__PURE__*/React.createElement("div", {
        className: "section-header form"
      }, /*#__PURE__*/React.createElement("div", {
        className: "option-container filter-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-row select"
      }, /*#__PURE__*/React.createElement("label", null, _this.props.translate('Subjects')), /*#__PURE__*/React.createElement("select", {
        value: _this.state.filter.subjectId,
        onChange: _this.filterOnSubject
      }, /*#__PURE__*/React.createElement("option", {
        value: "0"
      }, _this.props.translate('select-an-alternative')), _this.props.user.subjects != null && _this.props.user.subjects.map(function (subject) {
        return /*#__PURE__*/React.createElement("option", {
          value: subject.subjectId,
          key: subject.subjectId
        }, subject.title);
      })), _this.state.filter.subjectId > 0 ? /*#__PURE__*/React.createElement("div", {
        className: "clear-filter-container",
        onClick: _this.clearSubjectFilterSelection
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "Close"
      }), " ", _this.props.translate('clear-filter')) : null)));
    });

    _defineProperty(_assertThisInitialized(_this), "renderGroupsFilter", function () {
      var groups = _this.props.educationGroups;

      if (_this.state.filter.showArchivedLegacySections && Array.isArray(_this.props.archivedEducationGroups) && _this.props.archivedEducationGroups.length > 0) {
        groups = [].concat(_toConsumableArray(groups), _toConsumableArray(_this.props.archivedEducationGroups));
      }

      if (_this.state.filter.showArchivedLegacySections && Array.isArray(_this.props.legacyEducationGroups) && _this.props.legacyEducationGroups.length > 0) {
        groups = [].concat(_toConsumableArray(groups), _toConsumableArray(_this.props.legacyEducationGroups));
      }

      if (groups) {
        var groupIds = new Set();
        groups = groups.filter(function (group) {
          if (!groupIds.has(group.id)) {
            groupIds.add(group.id);
            return true;
          }

          return false;
        });
        groups.sort(function (a, b) {
          return a.title.toLowerCase().localeCompare(b.title.toLowerCase());
        });
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "section-header form"
      }, /*#__PURE__*/React.createElement("div", {
        className: "option-container filter-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-row select"
      }, /*#__PURE__*/React.createElement("label", null, _this.props.translate('Group')), /*#__PURE__*/React.createElement("select", {
        value: _this.state.filter.sectionId,
        onChange: _this.filterOnGroup
      }, /*#__PURE__*/React.createElement("option", {
        value: "0"
      }, _this.props.translate('select-an-alternative')), groups != null && groups.map(function (group) {
        return /*#__PURE__*/React.createElement("option", {
          value: group.id,
          key: group.id
        }, group.title);
      })), _this.state.filter.sectionId > 0 ? /*#__PURE__*/React.createElement("div", {
        className: "clear-filter-container",
        onClick: _this.clearGroupFilterSelection
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "Close"
      }), " ", _this.props.translate('clear-filter')) : null)));
    });

    _defineProperty(_assertThisInitialized(_this), "renderGroupsCheckBoxFilter", function () {
      return /*#__PURE__*/React.createElement("div", {
        className: "row align-items-left"
      }, /*#__PURE__*/React.createElement("div", {
        className: "row-item size-16"
      }, /*#__PURE__*/React.createElement(Checkbox, {
        value: _this.state.filter.showArchivedLegacySections,
        onChange: _this.handleArchivedAndLegacyGroupsVisibilityChange,
        label: _this.props.translate('View archived and deleted groups')
      })));
    });

    _defineProperty(_assertThisInitialized(_this), "onDateChange", function (dates) {
      var filter = _this.state.filter;
      filter.dates = dates;

      _this.setState({
        filter: filter
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onTermChange", function (value) {
      if (value != '') {
        var dStartDate = Moment();
        var startDate = Moment().format('YYYY-MM-DD');
        var dDueDate = Moment();
        var dueDate = Moment().format('YYYY-MM-DD');

        switch (value) {
          case 'year':
            if (Moment().month() < 7) {
              dStartDate = Moment().subtract(1, 'year').month(7).date(1);
              startDate = Moment().subtract(1, 'year').month(7).date(1).format('YYYY-MM-DD');
              dDueDate = Moment().month(6).date(31);
              dueDate = Moment().month(6).date(31).format('YYYY-MM-DD');
            } else {
              dStartDate = Moment().month(7).date(1);
              startDate = Moment().month(7).date(1).format('YYYY-MM-DD');
              dDueDate = Moment().add(1, 'year').month(6).date(31);
              dueDate = Moment().add(1, 'year').month(6).date(31).format('YYYY-MM-DD');
            }

            break;

          case 'previous-year':
            if (Moment().month() < 7) {
              dStartDate = Moment().subtract(2, 'year').month(7).date(1);
              startDate = Moment().subtract(2, 'year').month(7).date(1).format('YYYY-MM-DD');
              dDueDate = Moment().subtract(1, 'year').month(6).date(31);
              dueDate = Moment().subtract(1, 'year').month(6).date(31).format('YYYY-MM-DD');
            } else {
              dStartDate = Moment().subtract(1, 'year').month(7).date(1);
              startDate = Moment().subtract(1, 'year').month(7).date(1).format('YYYY-MM-DD');
              dDueDate = Moment().subtract(0, 'year').month(6).date(31);
              dueDate = Moment().subtract(0, 'year').month(6).date(31).format('YYYY-MM-DD');
            }

            break;

          case 'semester':
            if (Moment().month() < 7) {
              dStartDate = Moment().month(0).date(1);
              startDate = Moment().month(0).date(1).format('YYYY-MM-DD');
              dDueDate = Moment().month(6).date(31);
              dueDate = Moment().month(6).date(31).format('YYYY-MM-DD');
            } else {
              dStartDate = Moment().month(6).date(1);
              startDate = Moment().month(6).date(1).format('YYYY-MM-DD');
              dDueDate = Moment().month(11).date(31);
              dueDate = Moment().month(11).date(31).format('YYYY-MM-DD');
            }

            break;
        }

        _this.onDateChange({
          start: dStartDate,
          end: dDueDate
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderDatesFilter", function () {
      return /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "column section-header form"
      }, /*#__PURE__*/React.createElement("div", {
        className: "option-container filter-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-row select "
      }, /*#__PURE__*/React.createElement(DatePickerFromTo, {
        values: {
          start: Moment(_this.state.filter.dates.start),
          end: Moment(_this.state.filter.dates.end)
        },
        onChange: _this.onDateChange
      })))), /*#__PURE__*/React.createElement("div", {
        className: "column-3"
      }, /*#__PURE__*/React.createElement("div", {
        className: "term-change",
        style: {
          marginBottom: '0.5rem'
        }
      }, /*#__PURE__*/React.createElement(Select, {
        onChange: _this.onTermChange,
        options: [{
          label: _this.props.translate('current-schoolyear'),
          value: 'year'
        }, {
          label: _this.props.translate('previous-schoolyear'),
          value: 'previous-year'
        }, {
          label: _this.props.translate('current-semester'),
          value: 'semester'
        }]
      }, /*#__PURE__*/React.createElement("strong", {
        style: {
          marginBottom: '0.2rem'
        }
      }, _this.props.translate('select-period')))), /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        onClick: function onClick() {
          _this.reloadData();
        }
      }, _this.props.translate('Update'))));
    });

    _defineProperty(_assertThisInitialized(_this), "renderHeaderFilter", function () {
      return (
        /*#__PURE__*/
        // Create a section for filters with specified styling
        React.createElement("div", {
          className: "section",
          style: {
            margin: 0,
            padding: 0,
            border: 0,
            marginBottom: '1.5rem'
          }
        }, /*#__PURE__*/React.createElement("div", {
          className: "row"
        }, /*#__PURE__*/React.createElement("div", {
          className: "column-12"
        }, _this.renderDatesFilter())), /*#__PURE__*/React.createElement("div", {
          className: "row"
        }, /*#__PURE__*/React.createElement("div", {
          className: "column-6"
        }, _this.renderSubjectsFilter()), /*#__PURE__*/React.createElement("div", {
          className: "column"
        }, _this.renderGroupsFilter())), _this.renderGroupsCheckBoxFilter(), /*#__PURE__*/React.createElement("div", {
          className: "clearfix"
        }))
      );
    });

    _defineProperty(_assertThisInitialized(_this), "handleArchivedAndLegacyGroupsVisibilityChange", /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(isSelected) {
        var filter, _this$props, _this$props$archivedE, archivedEducationGroups, _this$props$legacyEdu, legacyEducationGroups;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                filter = _objectSpread(_objectSpread({}, _this.state.filter), {}, {
                  showArchivedLegacySections: isSelected
                }); // Destructuring archivedEducationGroups from props with a default value of an empty array

                _this$props = _this.props, _this$props$archivedE = _this$props.archivedEducationGroups, archivedEducationGroups = _this$props$archivedE === void 0 ? [] : _this$props$archivedE, _this$props$legacyEdu = _this$props.legacyEducationGroups, legacyEducationGroups = _this$props$legacyEdu === void 0 ? [] : _this$props$legacyEdu; // If 'isSelected' is true and there are no archived groups,
                // load archived groups and update the state

                if (!isSelected) {
                  _context5.next = 12;
                  break;
                }

                _this.setState({
                  loading: true
                });

                if (!(legacyEducationGroups.length === 0)) {
                  _context5.next = 7;
                  break;
                }

                _context5.next = 7;
                return _this.props.getLegacyEducationGroups();

              case 7:
                if (!(archivedEducationGroups.length === 0)) {
                  _context5.next = 10;
                  break;
                }

                _context5.next = 10;
                return _this.props.getArchivedEducationGroups();

              case 10:
                _this.setState({
                  loading: false,
                  filter: filter
                });

                return _context5.abrupt("return");

              case 12:
                // If 'isSelected' is false and the section ID in the filter matches an archived group ID,
                // set the section ID in the filter to 0
                if (!isSelected && filter.sectionId > 0 && (archivedEducationGroups.some(function (group) {
                  return group.id === filter.sectionId;
                }) || legacyEducationGroups.some(function (group) {
                  return group.id === filter.sectionId;
                }))) {
                  filter.sectionId = 0;
                } // Update the state with the new filter object


                _this.setState({
                  filter: filter
                });

              case 14:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      return function (_x2) {
        return _ref5.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "getFilteredAndSortedCourseGroup", function (groups) {
      var filter = _this.state.filter; // If `this.props.assessmentCourses` is null, undefined, or otherwise falsy, assign an empty array to `assessmentCourses`.
      // This ensures that `assessmentCourses` will always be an array and prevents errors.

      var assessmentCourses = _this.props.assessmentCourses || [];
      var subjectIds = new Set(_this.state.subjectIds.filter(function (subjectId) {
        return filter.subjectId === 0 || filter.subjectId === subjectId;
      }));
      var courses = [];

      var _iterator = _createForOfIteratorHelper(groups),
          _step;

      try {
        var _loop = function _loop() {
          var group = _step.value;
          // If group.courses doesn't exist or isn't an array, default it to an empty array
          var groupCourses = [].concat(_toConsumableArray(group.courses || []), _toConsumableArray(assessmentCourses.filter(function (data) {
            return data.sectionId === group.id;
          }).map(function (data) {
            return data.course;
          })));

          var _iterator2 = _createForOfIteratorHelper(groupCourses),
              _step2;

          try {
            var _loop2 = function _loop2() {
              var course = _step2.value;
              if (!subjectIds.has(course.subjectId)) return "continue";

              if (!courses.some(function (data) {
                return data.group.id === group.id && data.course.id === course.id;
              })) {
                courses.push({
                  course: course,
                  group: group
                });
              }
            };

            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var _ret = _loop2();

              if (_ret === "continue") continue;
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        };

        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          _loop();
        } // Sort the courses array based on the 'title' property in alphabetical order

      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      courses.sort(function (a, b) {
        return a.group.title.localeCompare(b.group.title);
      });
      return courses;
    });

    var _subjectIds = [];

    if (props.user.subjects != null) {
      props.user.subjects.forEach(function (subject) {
        if (getActiveSchool(props.user.id) == subject.schoolId) {
          _subjectIds.push(subject.subjectId);
        }
      });
    }

    var currentYear = new Date().getFullYear();
    var yearsList = [];

    for (var i = 0; i < 4; i++) {
      var schoolYear = "".concat(currentYear - i - 1, "/").concat(currentYear - i);
      yearsList.push({
        id: i + 1,
        text: schoolYear,
        from: currentYear - i - 1,
        to: currentYear - i
      });
    }

    _this.state = {
      loading: true,
      subjectIds: _subjectIds,
      years: [].concat(yearsList),
      filter: {
        subjectId: 0,
        showArchivedLegacySections: false,
        sectionId: 0,
        dates: getUserAssessmentDates()
      }
    };
    var storedFilter = localStorage.getItem("hal.subjectPageFilter");

    if (storedFilter != null) {
      _this.state.filter = JSON.parse(storedFilter);
    }

    return _this;
  }

  _createClass(SubjectPage, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      // If this.state.subjectIds is not an array or is empty, return a message
      if (this.state.subjectIds.length === 0) {
        return /*#__PURE__*/React.createElement("div", null, this.props.translate('no-subject-teacher-groups') + ' ' + this.props.translate('contact-your-school-administrator'));
      } // Default to an empty array if this.props.educationGroups is not an array


      var groups = _toConsumableArray(this.props.educationGroups || []); // Check if archivedEducationGroups exists and is an array before trying to access its length property


      if (this.state.filter.showArchivedLegacySections && Array.isArray(this.props.archivedEducationGroups) && this.props.archivedEducationGroups.length > 0) {
        groups = [].concat(_toConsumableArray(groups), _toConsumableArray(this.props.archivedEducationGroups));
      } // Check if legacyEducationGroups exists and is an array before trying to access its length property


      if (this.state.filter.showArchivedLegacySections && Array.isArray(this.props.legacyEducationGroups) && this.props.legacyEducationGroups.length > 0) {
        groups = [].concat(_toConsumableArray(groups), _toConsumableArray(this.props.legacyEducationGroups));
      } //Filter groups if any section has been choosen in the filter


      if (this.state.filter.sectionId > 0) groups = groups.filter(function (group) {
        return group.id === _this2.state.filter.sectionId;
      });
      var processedCourseGroups = this.getFilteredAndSortedCourseGroup(groups);
      return (
        /*#__PURE__*/
        // Render the UI elements
        React.createElement("div", {
          className: "verdict-course-page"
        }, this.renderHeaderFilter(), /*#__PURE__*/React.createElement(Block, null, /*#__PURE__*/React.createElement("h3", {
          className: "title",
          style: {
            marginBottom: '2rem'
          }
        }, this.props.translate('verdicts')), /*#__PURE__*/React.createElement("div", {
          className: "row",
          style: {
            marginBottom: '0.5rem'
          }
        }, /*#__PURE__*/React.createElement("div", {
          className: "column"
        }, /*#__PURE__*/React.createElement("strong", null, this.props.translate('Group'))), /*#__PURE__*/React.createElement("div", {
          className: "column"
        }, /*#__PURE__*/React.createElement("strong", null, this.props.translate('Curriculum')))), this.state.loading ? /*#__PURE__*/React.createElement("div", {
          style: {
            marginTop: '3rem',
            marginBottom: '1rem'
          },
          className: "row align-items-center"
        }, /*#__PURE__*/React.createElement(Spinner, null)) : /*#__PURE__*/React.createElement("div", {
          className: "courses"
        }, processedCourseGroups.length === 0 ? /*#__PURE__*/React.createElement("div", {
          className: "row align-items-center",
          style: {
            marginTop: '2rem',
            marginBottom: '1rem'
          }
        }, /*#__PURE__*/React.createElement("strong", null, this.props.translate('No groups found'))) : processedCourseGroups.map(this.renderGroupRow))))
      );
    }
  }]);

  return SubjectPage;
}(Component);

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations),
    user: state.user.currentUser,
    educationGroups: state.sections.educationGroups,
    legacyEducationGroups: state.sections.legacyEducationGroups,
    archivedEducationGroups: state.sections.archivedEducationGroups,
    assessmentCourses: state.assessments.courses
  };
}

export default connect(mapStateToProps, {
  setPageTitle: setPageTitle,
  getArchivedEducationGroups: getArchivedEducationGroups,
  getEducationGroups: getEducationGroups,
  getCoursesUsedWithinMySections: getCoursesUsedWithinMySections,
  getLegacyEducationGroups: getLegacyEducationGroups
})(SubjectPage);